import { makeApiCallWithAny} from "./tokenService";
import { DayBookingType } from "../models/dayBookingType/dayBookingType";

export const getDayBookingTypeItems = (
    signal: AbortSignal
): Promise<DayBookingType[]> => {
    return makeApiCallWithAny<DayBookingType[]>(
        "api/daybookingtypes",
        signal
    );
};
